import {SpProjectService} from './service/api/sp-project/sp-project.service';
import {SpBoardService} from './service/api/sp-board/sp-board.service';
import {SpBoardLaneService} from './service/api/sp-board-lane/sp-board-lane.service';
import {SpBoardTemplateService} from './service/api/sp-board-template/sp-board-template.service';
import {SpBoardTemplateLaneService} from './service/api/sp-board-template-lane/sp-board-template-lane.service';
import {SpSprintService} from './service/api/sp-sprint/sp-sprint.service';
import {SpProjectTicketService} from './service/api/sp-project-ticket/sp-project-ticket.service';
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {
    SpProjectObjectComponent
} from './component/protected-components/sp-project-object-component/sp-project-object.component';
import {
    SpSprintObjectComponent
} from './component/protected-components/sp-sprint-object-component/sp-sprint-object.component';

export const SP_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['sp.SpProject', {
                route: '/sp/dashboard',
                objectRoute: 'sp/project/:id',
                service: SpProjectService,
                objectComponent: [{component: SpProjectObjectComponent}]
            }],
            ['sp.SpBoard', {
                route: '/sp/dashboard',
                objectRoute: 'sp/board/:id',
                service: SpBoardService
            }],
            ['sp.SpBoardLane', {
                route: '/sp/dashboard',
                service: SpBoardLaneService
            }],
            ['sp.SpBoardTemplate', {
                route: '/sp/config',
                objectRoute: 'sp/boardTemplate/:id',
                service: SpBoardTemplateService
            }],
            ['sp.SpBoardTemplateLane', {
                route: '/sp/config',
                service: SpBoardTemplateLaneService
            }],
            ['sp.SpSprint', {
                route: '/sp/dashboard',
                objectRoute: 'sp/sprint/:id',
                service: SpSprintService,
                objectComponent: [{component: SpSprintObjectComponent}]
            }],
            ['sp.SpProjectTicket', {
                route: '/sp/dashboard',
                service: SpProjectTicketService
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
